
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2WarningDialog } from "../../../view/dialogs/Poker2WarningDialog";
import { Poker2SoundController } from "../../Poker2SoundController";
import { Poker2Command } from "../Poker2Command";

export class GGGCommand extends Poker2Command {
    protected get cmdId(): string {
        return "ggg";
    }
    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            Poker2Model.onTableData.parse_GGG(paramObj);

            this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_GIFT);
        }
        else if (error == 10) {
            this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"),
                Poker2Model.languageData.getTextById("alert_not_enough_chips")));
        }

        return (error == 0);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
